<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--team style1 start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h2 class="title">Team <span>Style 1</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="team-member">
          <h5><a href="team-single.html">Jesson<br>Mart</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/01.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="team-member">
          <h5><a href="team-single.html">Michael<br>Vegas</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/02.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="team-member">
          <h5><a href="team-single.html">Charlote<br>Kerry</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/03.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team style1 end-->


<!--team style2 start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
           <h2 class="title">Team <span>Style 2</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <div class="team-member style-2">
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/01.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-2">
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/02.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-description">
            <h5><a href="team-single.html">Michael Vegas</a></h5>
            <span>Manager</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-2">
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/03.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          <div class="team-description">
            <h5><a href="team-single.html">Charlote Kerry</a></h5>
            <span>Ceo</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team style2 end-->


<!--team style3 start-->

<section class="pt-0">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h2 class="title">Team <span>Style 3</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <div class="team-member style-3">
          <div class="team-images">
            <img class="img-fluid" src="images/team/01.jpg" alt="">
            <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          </div>          
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-3">
          <div class="team-images">
            <img class="img-fluid" src="images/team/02.jpg" alt="">
            <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          </div>          
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-3">
          <div class="team-images">
            <img class="img-fluid" src="images/team/03.jpg" alt="">
            <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          </div>          
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team style3 end-->

</div>

<!--body content end--> 
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: "shortcode-team",
        }
    }
}
</script>